import { NotificationDto } from '@careapp-group/ng-sdk-v2-new';
import { CAAction } from '../actions';
import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';
import { Notifications } from './notifications.actions';

export interface NotificationsStateInterface extends DataListState<NotificationDto> {
  unseenCount: number;
  loading: boolean;
}

class NotificationsState extends ReducerStateFactory<NotificationDto> {
  readonly initialState: NotificationsStateInterface = {
    ...INITIAL_DATA_LIST_STATE,
    loading: false,
    unseenCount: 0,
  };

  constructor(actions) {
    super(actions);
  }

  public reducer(state = this.initialState, action: CAAction): NotificationsStateInterface {
    switch (action.type) {
      case Notifications.RESPONSE_SUCCESS_SET_NOTIFICATION_READ: {
        const existingEntity = state.entities[action.payload.id] ?? {};
        return {
          ...state,
          entities: {
            ...state.entities,
            [action.payload.id]: { ...existingEntity, ...action.payload },
          },
          unseenCount: Math.max(0, state.unseenCount - 1),
        };
      }

      case Notifications.REQUEST_DISMISS_ALL_NOTIFICATIONS: {
        return { ...state, loading: false, unseenCount: 0, ids: [], entities: {} };
      }

      case Notifications.REQUEST_DISMISS_NOTIFICATION: {
        // Optimistic remove
        let unseenCount = state.unseenCount;
        if (state.entities[action.payload.id]?.seen === false) {
          unseenCount = Math.max(0, unseenCount - 1);
        }
        const ids = [...state.ids].filter((id) => id !== action.payload.id);
        const entities = ids.reduce(
          (prev, next) => ({
            ...prev,
            [next]: state.entities[next],
          }),
          {}
        );

        return {
          ...state,
          entities,
          ids,
          unseenCount,
        };
      }

      case Notifications.REQUEST_UNSEEN_NOTIFICATION_COUNT: {
        return { ...state, loading: true };
      }
      case Notifications.RESPONSE_FAIL_UNSEEN_NOTIFICATION_COUNT: {
        return { ...state, loading: false };
      }
      case Notifications.RESPONSE_SUCCESS_UNSEEN_NOTIFICATION_COUNT: {
        return { ...state, loading: false, unseenCount: action.payload };
      }

      default:
        return <any>super.reducer(state, action);
    }
  }
}

export const state = new NotificationsState(Notifications);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
